import { gql } from "@apollo/client";

export const INTERVIEW_FOR_VIDEO_PLAYER_GQL = gql`
  query InterviewForVideoPlayer($id: String!) {
    interviewForVideoPlayer(id: $id) {
      _id
      durations
      recording {
        _id
        state
      }
    }
  }
`;
